import { Anchor } from 'components/atoms';
import React from 'react';
import type { OtsAussendung } from 'types/unternehmen';
import { useTranslation } from 'utils/hooks';

import css from './OTSAussendung.module.scss';

interface OTSAussendungProps
{
  aussendung: OtsAussendung;
}

const OTSAussendung: React.FC<OTSAussendungProps> = (props) =>
{
  const { t } = useTranslation('profiles');
  const { aussendung } = props;

  return (
    <li className={css.aussendung}>
      <Anchor href={aussendung.weblink} target="_blank" external>
        {aussendung.titel}
      </Anchor>

      <div className={css.meta}>
        {t('profiles:unternehmen.aussendungen.ots.date', { date: aussendung.datum })}
      </div>

      <div dangerouslySetInnerHTML={{ __html: aussendung.lead }} />
    </li>
  );
};

export default OTSAussendung;
